import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const MeasurementsListSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema(['createdAt', 'producer', 'measuringMethod', 'status'])
);
